export default __webpack_public_path__ + "static/media/word.7011bd7e.png";